import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsChevronDown } from "react-icons/bs";
import { BsChevronUp } from "react-icons/bs";

// import { MetaTags } from 'react-meta-tags';
import { CUSTOMERDATA, CUSTOMERS } from "../../../../assets/graphql";
import { saveUserData } from "../../../../features/login/loginDataSlice";
import { apiHandler } from "../../../../api";
import { endpoint } from "../../../../api/endpoint";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Carousel from "better-react-carousel";

import "./style.css";

const MyDot = ({ isActive }) => (
  <span
    style={{
      display: "inline-block",
      height: isActive ? "8px" : "5px",
      width: isActive ? "8px" : "5px",
      background: "#1890ff",
    }}
  ></span>
);

const Customers = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.login);

  const [openWaranty, setOpenWaranty] = React.useState(false);
  const [customerData, setCustomerData] = useState({});

  const getCustomers = async (id) => {
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      // authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {},
        query: CUSTOMERS,
      },
    });
    setCustomerData(result.data);

    // if (!result.data.error_code) {
    //   dispatch(saveproductDetails(result.data.products.items));
    // }
  };
  const validateLoggedInUser = async () => {
    const customerResult = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {},
        query: CUSTOMERDATA,
      },
    });
    if (customerResult.data && customerResult.data.customer) {
      dispatch(saveUserData(customerResult.data.customer));
    } else {
      toast.error(customerResult.data.customer.message);
    }
  };
  useEffect(() => {
    validateLoggedInUser();
    getCustomers();
  }, []);

  const renderHTML = (rawHTML) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  const unescapeHTML = (html) => {
    var escapeEl = document.createElement("textarea");
    escapeEl.innerHTML = html;
    return escapeEl.textContent;
  };
  return (
    <>
      <section className="customerSection new-pb owl-Carousel-team-computer">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 mx-auto text-center py-5">
              <div className="mainsection-title">
                <h2>Our Customers</h2>
              </div>
            </div>
          </div>
          <div className="owl-carousel owl-theme circle-slider circle no-arrow customerImag">
            <Carousel cols={5} rows={1} gap={10} autoplay={3000} loop={true}>
              {customerData &&
                customerData.getCompanies &&
                customerData.getCompanies.map((item, index) => (
                  <Carousel.Item>
                    <img
                      className="imageStyle"
                      src={
                        item.logo
                          ? item.logo
                          : "https://shopuat.teamcomputers.com:446/magento/pub/media/company/dummy-img.jpg"
                      }
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
        </div>
      </section>
    </>
  );
};
export default Customers;
